export default "__VITE_ASSET__DL49QgRQ__"